<template>
	<section class="tabbed-body-layout">
		<header v-if="$slots.header" class="tabbed-body-layout-header">
			<slot name="header"></slot>
		</header>
		<section class="tabbed-body-layout-tabs">
			<slot name="tabs"></slot>
		</section>
		<main :class="panelsClasses">
			<slot name="panels"></slot>
			<footer class="tabbed-body-layout-panels-footer" v-if="$slots.footer">
				<slot name="footer"></slot>
			</footer>
		</main>
	</section>
</template>

<script>

export default {
	name: "TabbedBodyLayout",
	emits: [ "panelSelected", ],
	props: {
		scrollPanels: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		panelsClasses() {
			return {
				"tabbed-body-layout-panels": true,
				"tabbed-body-layout-panels--scrollable": this.scrollPanels,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.tabbed-body-layout {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 1rem;

	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	width: 100%;

	padding: 1rem 1rem 0 1rem;

	@include for-size('md') {
		gap: 1.5rem;
		padding: 2rem 2rem 0 2rem;
	}
}

.tabbed-body-layout-panels {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 1rem;

	position: relative;
}

.tabbed-body-layout-panels--scrollable {
	@include auto-y-scroll();
}
</style>
